<template>
  <div class="topbar">
    <div class="topbar-left">
      <!-- 可以放置面包屑或其他导航 -->
    </div>

    <div class="topbar-right">
      <!-- 升级套餐按钮 -->
      <el-button v-if="!isBusinessUser" class="upgrade-btn" size="small" @click="goToPricing">
        <i class="el-icon-trophy"></i>
        会员
      </el-button>

      <!--      &lt;!&ndash; 剪贴板图标 &ndash;&gt;-->
      <!--      <el-button icon="el-icon-document-copy" circle size="small"></el-button>-->

      <!--      &lt;!&ndash; 通知图标（带红点） &ndash;&gt;-->
      <!--      <el-badge :value="1" class="notification-badge">-->
      <!--        <el-button icon="el-icon-bell" circle size="small"></el-button>-->
      <!--      </el-badge>-->

      <!-- 用户头像下拉菜单 -->
      <el-dropdown trigger="hover" @command="handleCommand">
        <div class="avatar-trigger">
          <span v-if="isBusinessUser" class="enterprise-avatar-badge">企业版</span>
          <el-avatar class="user-avatar" :size="32" :src="getAvatar"></el-avatar>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <!-- 用户信息头部 -->
          <div class="user-info-header">
            <el-avatar :size="48" :src="getAvatar"></el-avatar>
            <div class="user-info-text">
              <div class="username">{{ userInfo.name || '用户' }}</div>
              <div class="user-level" :class="{'enterprise-level': isBusinessUser}">
                {{ accountVersionText }}
              </div>
            </div>
          </div>
          <el-dropdown-item command="account" class="menu-item">账号信息</el-dropdown-item>
          <el-dropdown-item command="logout" class="menu-item logout-item">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('xm-user') || '{}'),
      sidebarVisible: true // 控制侧边栏显示
    }
  },
  created() {
    this.$request.get('/user/getInfo').then(res => {
      this.userInfo = res.data
      localStorage.setItem('xm-user', JSON.stringify(res.data))
    })
  },
  computed: { //这个属性就可以，在里面声明初始化时要调用的方法即可
    getAvatar() {
      if (this.userInfo.avatar) {
        return this.userInfo.avatar;
      } else {
        return 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
      }
    },
    isExpired() {
      if (this.userInfo.expireTime) {
        const currentTime = new Date();
        const expireTime = new Date(this.userInfo.expireTime);
        return expireTime > currentTime;
      } else {
        return false;
      }
    },
    isBusinessUser() {
      return this.userInfo && this.userInfo.tenant === 'business';
    },
    accountVersionText() {
      if (this.isBusinessUser) {
        return '企业版';
      }
      if (this.userInfo.highExpireTime) {
        return '高级会员版';
      }
      if (this.userInfo.expireTime) {
        return '普通会员版';
      }
      return '体验版';
    }
  },
  methods: {
    goToPricing() {
      this.$router.push('/recharge');
    },
    goToPerson() {
      this.$router.push('/adminPerson');
    },
    logout() {
      // 保存当前的用户信息到数据库
      this.$request.post('/user/logout', this.userInfo).then(res => {
        if (res.code === '200') {
          localStorage.removeItem('xm-user');
          // 成功更新
          this.$message.success('注销成功')
          this.$router.push('/login');
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCommand(command) {
      switch (command) {
        case 'account':
          this.$router.push('/account-settings');
          break;
        case 'logout':
          this.logout();
          // 这里可以添加退出登录的逻辑
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style scoped>
.topbar {
  height: 60px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: fixed;
  top: 0;
  left: 175px;
  right: 0;
  z-index: 100;
}

.topbar-left {
  flex: 1;
}

.topbar-right {
  margin-right: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.upgrade-btn {
  background: #fef3c7;
  border-color: #fef3c7;
  color: #d97706;
  font-weight: 500;
}

.upgrade-btn:hover {
  background: #fde68a;
  border-color: #fde68a;
}

.upgrade-btn i {
  margin-right: 4px;
}

.coin-display {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #fff7ed;
  border-radius: 16px;
  color: #ea580c;
  font-weight: 500;
  font-size: 14px;
}

.coin-display i {
  font-size: 16px;
  color: #f59e0b;
}

.notification-badge {
  line-height: 1;
}

.notification-badge ::v-deep .el-badge__content {
  background-color: #ef4444;
  border: none;
}

.user-avatar {
  cursor: pointer;
  transition: transform 0.2s;
}

.avatar-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.enterprise-avatar-badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  color: #7c4a03;
  border: 1px solid #f3cf7a;
  background: linear-gradient(135deg, #fff7d6 0%, #f4c45f 100%);
  box-shadow: 0 4px 12px rgba(194, 128, 8, 0.18);
  font-size: 12px;
  font-weight: 700;
}

::v-deep .el-button.is-circle {
  border-color: #e5e7eb;
}

::v-deep .el-button.is-circle:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

/* 用户下拉菜单样式 */
::v-deep .user-dropdown {
  width: 220px;
  padding: 0;
  margin-top: 8px;
}

.user-info-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.user-info-text {
  flex: 1;
  min-width: 0;
}

.username {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-level {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
}

.enterprise-level {
  color: #7c4a03;
  border: 1px solid #f3cf7a;
  background: linear-gradient(135deg, #fff7d6 0%, #f4c45f 100%);
  box-shadow: 0 4px 12px rgba(194, 128, 8, 0.18);
}

::v-deep .menu-item {
  padding: 12px 20px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

::v-deep .menu-item:hover {
  background: #f5f5f5;
  color: #409eff;
}

::v-deep .logout-item {
  color: #f56c6c;
  border-top: 1px solid #f0f0f0;
}

::v-deep .logout-item:hover {
  background: #fef0f0;
  color: #f56c6c;
}
</style>
